// extracted by mini-css-extract-plugin
export default {"root":"VerticalScrollList-module-root","listItem":"VerticalScrollList-module-listItem"};